export default __webpack_public_path__ + "b2075855b0070166f06ae197ac39c8c3.svg";